module.exports = __webpack_public_path__ + "static/media/20170806_32day_1603AT.e0122092.jpg";